// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marketing-header {
  min-height: 60px;
  display: flex;
  align-items: center;
  padding: 0 10px;
}
.marketing-header .marketing-lastupdate {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.marketing-header .marketing-search-box {
  color: #6A8991;
  font-size: 17px;
  display: flex;
  align-items: center;
  margin-left: 10px;
}
.marketing-header .marketing-search-box .marketing-search-input {
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 17px;
  color: #6A8991;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Marketing/Marketing.scss"],"names":[],"mappings":"AAAA;EACC,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;AACF;AAEC;EACC,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AAAF;AAEE;EACC,6BAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AAAH","sourcesContent":[".marketing-header {\n\tmin-height: 60px;\n\tdisplay: flex;\n\talign-items: center;\n\tpadding: 0 10px;\n\n\t.marketing-lastupdate {\n\t\twidth: 100%;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-end;\n\t}\n\n\t.marketing-search-box {\n\t\tcolor: #6A8991;\n\t\tfont-size: 17px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tmargin-left: 10px;\n\n\t\t.marketing-search-input {\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t\toutline: 0;\n\t\t\tfont-size: 17px;\n\t\t\tcolor: #6A8991;\n\t\t\theight: 30px;\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
